// 跟消息相关的接口
import request from '../../request'
import download from '../../download'

export function fetchList(params) {
    return request({
        url: '/office-service/giftMaterial/list',
        params,
    })
}

export function add(data) {
    return request({
        url: '/office-service/giftMaterial/add',
        data,
        method: "post",
    })
}

export function addStorage(data) {
    return request({
        url: '/office-service/giftWarehouseEntry/add',
        data,
        method: "post",
    })
}

export function edit(data) {
    return request({
        url: '/office-service/giftMaterial/update',
        data,
        method: "post",
    })
}

// 调整库存
export function adjust(data) {
    return request({
        url: '/office-service/giftMaterial/adjust',
        data,
        method: "post",
    })
}

// 申请物料
export function apply(data) {
    return request({
        url: '/office-service/giftMaterialApply/apply',
        data,
        method: "post"
    })
}

// 申领台账
export function fetchApplyList(data) {
    return request({
        url: '/office-service/giftMaterialApply/standingBook',
        data,
        method: 'post'
    })
}
export function fetchWareList(params) {
    return request({
        url: '/office-service/giftWarehouseEntry/list',
        params,
    })
}
export function fetchWareDetail(id) {
    return request({
        url: '/office-service/giftWarehouseEntry/detail/' + id,
    })
}
export function fetchApplyDeptList(data) {
    return request({
        url: '/office-service/giftMaterialApply/standingBookDept',
        data,
        method: 'post'
    })
}

export function fetchApplyDetail(data) {
    return request({
        url: `/office-service/giftMaterialApply/query/${data.id}`,
        method: "post"
    })
}

export function reapply(data) {
    return request({
        url: '/office-service/giftMaterialApply/reApply',
        data,
        method: 'post'
    })
}

// 领用记录
export function fetchApplyRecord(data) {
    return request({
        url: '/office-service/giftMaterialApply/record',
        data,
        method: 'post'
    })
}

// 领用记录-导出
export function exportApplyRecord(data) {
    return download({
        url: '/office-service/giftMaterialApply/exportExc',
        data,
        method: 'post'
    })
}

// 修改领用数量
export function updateApplyQuantity(data) {
    return request({
        url: '/office-service/giftMaterialApply/updateQuantity',
        data,
        method: 'post'
    })
}

// 领用记录-修改日志
export function fetchApplyRecordLog(applyId) {
    return request({
        url: `/office-service/giftMaterialApply/recordLog/${applyId}`,
        method: 'post'
    })
}